export const STORAGE_KEY = "todos-vuejs";

// for testing
if (navigator.userAgent.indexOf("PhantomJS") > -1) {
  window.localStorage.clear();
}
export const mutations = {
  login(state, currentUser) {
    state.currentUser = currentUser;
  },
  logout(state) {
    state.currentUser = undefined;
    state.cart = [];
    localStorage.setItem("cart", JSON.stringify(state.cart));
  },

  toggleMenu(state) {
    state.showMenu = !state.showMenu;
    if (state.showMenu) {
      document.documentElement.className = "nav-open";
    } else {
      document.documentElement.className = "";
    }
  },
  addToCart(state, cart_item) {
    var i = state.cart.findIndex(
      (item) => item.offer._id == cart_item.offer._id
    );
    if (i >= 0) {
      state.cart[i].qtd += cart_item.qtd;
    } else {
      state.cart.push(cart_item);
    }
    localStorage.setItem("cart", JSON.stringify(state.cart));
  },
  removeFromCart(state, index) {
    delete state.cart[index];
    state.cart.splice(index, 1);
    localStorage.setItem("cart", JSON.stringify(state.cart));
  },
  clearCart(state) {
    state.cart = [];
    localStorage.setItem("cart", JSON.stringify(state.cart));
  },
  updateBanner(state, data) {
    state.banner = data;
  },
  setActiveOrder(state, order) {
    state.activeOrder = order;
  },
  startChatWith(state, userId) {
    state.newChatRequest = userId;
  },
};
